import { AccordionBodyItemView } from 'component/Accordion';
import React from 'react';

export const DescriptionPlaceView = (props) => {
  const {
    formData,
    translatedFormData,
    translateState,
  } = props;

  return (
    <AccordionBodyItemView
      accordionSubId="2.9"
      titleUA="Опис типу місця"
      titleEN="Description of place type"
      children={(
        <span>
          {translateState && translatedFormData?.description_of_place_type}
          {!translateState && formData?.info?.session_information?.description_of_place_type}
        </span>
      )}
    />
  );
};
